import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import FieldTip from '../ui/FieldTip';

const ConvertibleFields = ({ formData, onFieldChange }) => {
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="conversion_ratio" className="portfolio-input-label">Conversion Ratio<FieldTip field="conversion_ratio" /></Label>
        <Input
          id="conversion_ratio"
          data-testid="conversion-ratio-input"
          type="number"
          step="0.01"
          placeholder="e.g. 1.25"
          value={formData.conversion_ratio}
          onChange={(e) => onFieldChange('conversion_ratio', e.target.value)}
          className="portfolio-input"
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="discount_rate" className="portfolio-input-label">Discount Rate (%)</Label>
        <Input
          id="discount_rate"
          data-testid="discount-rate-input"
          type="number"
          step="0.01"
          placeholder="e.g. 20"
          value={formData.discount_rate}
          onChange={(e) => onFieldChange('discount_rate', e.target.value)}
          className="portfolio-input"
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="valuation_cap" className="portfolio-input-label">Valuation Cap<FieldTip field="valuation_cap" /></Label>
        <Input
          id="valuation_cap"
          data-testid="valuation-cap-input"
          type="number"
          placeholder="e.g. 10000000"
          value={formData.valuation_cap}
          onChange={(e) => onFieldChange('valuation_cap', e.target.value)}
          className="portfolio-input"
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="interest_rate" className="portfolio-input-label">Interest Rate (%)</Label>
        <Input
          id="interest_rate"
          data-testid="interest-rate-convertible-input"
          type="number"
          step="0.01"
          placeholder="e.g. 8"
          value={formData.interest_rate}
          onChange={(e) => onFieldChange('interest_rate', e.target.value)}
          className="portfolio-input"
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="maturity_date" className="portfolio-input-label">Maturity Date</Label>
        <Input
          id="maturity_date"
          data-testid="maturity-date-convertible-input"
          type="date"
          value={formData.maturity_date}
          onChange={(e) => onFieldChange('maturity_date', e.target.value)}
          className="portfolio-input"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="tenor" className="portfolio-input-label">Tenor<FieldTip field="tenor" /></Label>
        <select
          id="tenor"
          data-testid="tenor-convertible-select"
          value={formData.tenor || ''}
          onChange={(e) => onFieldChange('tenor', e.target.value)}
          className="portfolio-input w-full h-10 rounded-md border border-input bg-background px-3 py-2 text-sm"
        >
          <option value="">Select tenor</option>
          <option value="1_year">1 Year</option>
          <option value="2_years">2 Years</option>
          <option value="3_years">3 Years</option>
          <option value="5_years">5 Years</option>
          <option value="7_years">7 Years</option>
          <option value="10_years">10 Years</option>
        </select>
      </div>
    </>
  );
};

export default ConvertibleFields;
